module.exports = __webpack_public_path__ + "img/ic-logo-wise.e6df9764.svg";